export const CONSUMPTION_TYPE = {
    IN_CITY: 'IN_CITY',
    ON_HIGHWAY: 'ON_HIGHWAY',
    ELECTRIC: 'ELECTRIC',
};

export const CONSUMPTION_UNIT = {
    L_KM: 'L_KM',
    MILES_GAL: 'MILES_GAL',
    KW_H: 'KW_H',
};

export const VEHICLE_STATUS = {
    DELIVERED: 'DELIVERED',
    FOR_SALE: 'FOR_SALE',
    ON_HOLD: 'ON_HOLD',
    SOLD: 'SOLD',
    VIRTUAL: 'VIRTUAL',
    DELETED: 'DELETED',
};

export const VEHICLE_CONDITION = {
    NEW: 'new',
    DEMO: 'newDemonstrator',
    USED: 'used',
    CERTIFIED: 'usedCertified',
};

export const VEHICLE = {
    CONSUMPTION_TYPE,
    CONSUMPTION_UNIT,
    VEHICLE_STATUS,
    VEHICLE_CONDITION,
    CONDITIONS: {
        NEW: 0x1,
        DEMO: 0x3,
        USED: 0x100,
        CERTIFIED: 0x300,
    },
};

export default VEHICLE;
